import React from "react";
import "../../../CSS/Home.css";
import "../../../CSS/main.css";
import {
  CiMonitor,
  CiSearch,
  CiHospital1,
  CiStethoscope,
  CiCamera,
  CiSettings,
  CiWavePulse1,
  CiBrightnessDown,
  CiMicrochip,
} from "react-icons/ci";
import { IoShieldOutline, IoCarOutline, IoLeafOutline } from "react-icons/io5";
import { MdOutlineManageHistory, MdOutlinePeopleAlt } from "react-icons/md";
import { GiEternalLove } from "react-icons/gi";
import { BsCameraReels } from "react-icons/bs";
import { HiMiniSignal, HiOutlineBuildingLibrary } from "react-icons/hi2";
import { GrUserWorker } from "react-icons/gr";
import { LuChevronsLeftRight } from "react-icons/lu";
import SkillDevelopment from "./SkillDevelopment";
import SectorSkillCouncils from "./SectorSkillCouncils";

const divStyle = {
  color: "#183b56",
};

const EmployabilityBoostProgramObj = [
  {
    icon: <CiMonitor size={40} />,
    program: "Digital Marketing",
  },
  {
    icon: <CiSearch size={40} />,
    program: "SEO",
  },
  {
    icon: <IoShieldOutline size={40} />,
    program: "Security Management",
  },
  {
    icon: <MdOutlineManageHistory size={40} />,
    program: "Facility Management",
  },
  {
    icon: <CiHospital1 size={40} />,
    program: "Hospitality Management",
  },
  {
    icon: <GiEternalLove size={40} />,
    program: "Patient Care",
  },
  {
    icon: <MdOutlinePeopleAlt size={40} />,
    program: "Geriatric Care",
  },
  {
    icon: <CiStethoscope size={40} />,
    program: "General Duty Assistance",
  },
  {
    icon: <CiCamera size={40} />,
    program: "CCTV Installation Technician",
  },
  {
    icon: <CiSettings size={40} />,
    program: "Multi Skill Technician",
  },
  {
    icon: <CiBrightnessDown size={40} />,
    program: "Solar Panel Installation Technician",
  },
  {
    icon: <IoCarOutline size={40} />,
    program: "Automotive Skills Development Council",
  },
  {
    icon: <BsCameraReels size={40} />,
    program: "Media and Entertainment Sector Skill Council",
  },
  {
    icon: <CiMicrochip size={40} />,
    program: "Electronics Sector Skill Council",
  },
  {
    icon: <HiMiniSignal size={40} />,
    program: "Telecom Sector Skill Council",
  },
  {
    icon: <HiOutlineBuildingLibrary size={40} />,
    program: "Construction Sector Skill Council",
  },
  {
    icon: <GrUserWorker size={40} />,
    program: "Domestic Workers Skill Council of India",
  },
  {
    icon: <IoLeafOutline size={40} />,
    program: "Skill Council for Green Jobs",
  },
  {
    icon: <CiWavePulse1 size={40} />,
    program: "Healthcare Sector Council",
  },
  {
    icon: <LuChevronsLeftRight size={40} />,
    program: "NASSCOM",
  },
];

const EmployabilityBoostProgram = () => {
  return (
    <div className="container-fluid bg-body-tertiary d-flex flex-column gap-5">
      <h3
        style={divStyle}
        className="title-styling pt-5 text-center fw-medium"
      >
        Employability Boost Programs
      </h3>

      {/* <div className="d-flex w-100 flex-wrap p-5">
        {EmployabilityBoostProgramObj.map((obj) => {
          return (
            <div
              className=" card border border-1 gap-5 shadow-sm hover-shadow Employabilitybody"
              style={{ transition: "all 0.3s ease" }}
            >
              <div className="w-100 h-100">
                <div
                  className="p-2 gap-3 Employabilitycard"
                  // style={{ backgroundColor: "#183b56" }}
                >
                  <h2 className="">{obj?.icon}</h2>
                  <div className="flex-grow-1 Employabilitytext">
                    <h6 className="mb-0 w-fit">{obj?.program}</h6>
                  </div>
                </div>
              </div>
              <style
                dangerouslySetInnerHTML={{
                  __html: `
          .hover-shadow:hover {
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
            transform: translateY(-2px);
          }
        `,
                }}
              />
            </div>
          );
        })}
      </div> */}
      <SkillDevelopment />
      <SectorSkillCouncils />
    </div>
  );
};

export default EmployabilityBoostProgram;
